import { render, staticRenderFns } from "./wsGOSTGradeSelector.vue?vue&type=template&id=3c980530"
import script from "./wsGOSTGradeSelector.vue?vue&type=script&lang=js"
export * from "./wsGOSTGradeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports